/**
 * Apply the Design System to a single Drupal behavior
 */

// ECMAScript polyfills, but NOT fetch(). Fetch() is web standard, not ECMAScript.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableAllComponents } from '../../source/baykis';
import AppDiagrams from '../../source/baykis/clientside/react/apps/data-viewer/AppDiagrams';
import AppDownloads from '../../source/baykis/clientside/react/apps/data-viewer/AppDownloads';
import RegionalAnalysis from '../../source/baykis/clientside/react/apps/regionalAnalysis/AppRegional';

require('./scss/_drupal-styles.scss');

Drupal.behaviors.designSystem = {
  attach($context, settings) {
    // Let's pretend we have a Drupal module called customCarouselModule that
    // provides a key on settings called `customCarouselModule` that has a key
    // called `interval`. Since this won't exist out of the box, we'll also
    // provide a default fallback object: { interval: 5000 }. Change this in
    // actual implementation.
    const { customCarouselModule = { interval: 5000 } } = settings;

    // Provide overrides to components from Drupal settings
    const componentSettings = {
      carousel: {
        interval: customCarouselModule.interval,
      },
      // .. other component overrides go here
    };

    // Now enable all components with a custom componentSettings object
    // enableAllComponents($context, componentSettings);
  },
};

Drupal.behaviors.app = {
  // eslint-disable-next-line no-unused-vars
  attach($context, settings) {
    const appDiagrams = document.getElementById('react-diagrams');
    const appDownloads = document.getElementById('react-downloads');
    const regionalAnalysis = document.getElementById('react-regional-analysis');

    if (appDiagrams) {
      ReactDOM.render(
        React.createElement(
          AppDiagrams,
          {
            apiurl: appDiagrams.getAttribute('data-api'),
            vistype: appDiagrams.getAttribute('data-type'),
            context: appDiagrams.getAttribute('data-context'),
            epoch: appDiagrams.getAttribute('data-epoch'),
          },
          null
        ),
        appDiagrams
      );
    }

    if (appDownloads) {
      ReactDOM.render(
        React.createElement(
          AppDownloads,
          {
            apiUrl: appDownloads.getAttribute('data-api'),
          },
          null
        ),
        appDownloads
      );
    }

    if (regionalAnalysis) {
      ReactDOM.render(
        React.createElement(
          RegionalAnalysis,
          {
            apiUrl: regionalAnalysis.getAttribute('data-api'),
          },
          null
        ),
        regionalAnalysis
      );
    }
  },
};

Drupal.behaviors.tabs = {
  // eslint-disable-next-line no-unused-vars
  attach($context, settings) {
    const tablist = document.querySelectorAll('[role="tablist"]')[0];

    if (!tablist) return;

    let tabs;
    let panels;

    function generateArrays() {
      tabs = document.querySelectorAll('[role="tab"]');
      panels = document.querySelectorAll('[role="tabpanel"]');
    }

    // For easy reference
    const keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46,
      enter: 13,
      space: 32,
    };

    // Add or subtract depending on key pressed
    const direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1,
    };

    // Make a guess
    const focusFirstTab = () => {
      tabs[0].focus();
    };

    // Make a guess
    const focusLastTab = () => {
      tabs[tabs.length - 1].focus();
    };

    // When a tablistâ€™s aria-orientation is set to vertical,
    // only up and down arrow should function.
    // In all other cases only left and right arrow function.

    // Either focus the next, previous, first, or last tab
    // depending on key pressed
    const switchTabOnArrowPress = (event) => {
      const pressed = event.keyCode;

      if (direction[pressed]) {
        const { target } = event;
        if (target.index !== undefined) {
          if (tabs[target.index + direction[pressed]]) {
            tabs[target.index + direction[pressed]].focus();
          } else if (pressed === keys.left || pressed === keys.up) {
            focusLastTab();
          } else if (pressed === keys.right || pressed === keys.down) {
            focusFirstTab();
          }
        }
      }
    };

    const determineOrientation = (event) => {
      const key = event.keyCode;
      const vertical = tablist.getAttribute('aria-orientation') === 'vertical';
      let proceed = false;

      if (vertical) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else if (key === keys.left || key === keys.right) {
        proceed = true;
      }

      if (proceed) {
        switchTabOnArrowPress(event);
      }
    };

    // Deactivate all tabs and tab panels
    const deactivateTabs = () => {
      for (let t = 0; t < tabs.length; t += 1) {
        tabs[t].setAttribute('tabindex', '-1');
        tabs[t].setAttribute('aria-selected', 'false');
      }

      for (let p = 0; p < panels.length; p += 1) {
        panels[p].setAttribute('hidden', 'hidden');
      }
    };

    // Activates any given tab panel
    const activateTab = (tab, setFocus) => {
      const Focus = setFocus || true;
      // Deactivate all other tabs
      deactivateTabs();

      // Remove tabindex attribute
      tab.removeAttribute('tabindex');

      // Set the tab as selected
      tab.setAttribute('aria-selected', 'true');

      // Get the value of aria-controls (which is an ID)
      const controls = tab.getAttribute('aria-controls');

      // Remove hidden attribute from tab panel to make it visible
      document.getElementById(controls).removeAttribute('hidden');

      // Set focus when required
      if (Focus) {
        tab.focus();
      }
    };

    // When a tab is clicked, activateTab is fired to activate it
    const clickEventListener = (event) => {
      const tab = event.target;
      activateTab(tab, false);
    };

    // Deletes a tab and its panel
    const deleteTab = (event) => {
      const { target } = event;
      const panel = document.getElementById(
        target.getAttribute('aria-controls')
      );

      target.parentElement.removeChild(target);
      panel.parentElement.removeChild(panel);
    };

    // Detect if a tab is deletable
    const determineDeletable = (event) => {
      const { target } = event;

      if (target.getAttribute('data-deletable') !== null) {
        // Delete target tab
        deleteTab(event, target);

        // Update arrays related to tabs widget
        generateArrays();

        // Activate the closest tab to the one that was just deleted
        if (target.index - 1 < 0) {
          activateTab(tabs[0]);
        } else {
          activateTab(tabs[target.index - 1]);
        }
      }
    };

    // Handle keyup on tabs
    const keyupEventListener = (event) => {
      const key = event.keyCode;

      switch (key) {
        case keys.left:
        case keys.right:
          determineOrientation(event);
          break;
        case keys.delete:
          determineDeletable(event);
          break;
        case keys.enter:
        case keys.space:
          activateTab(event.target);
          break;
        default:
          break;
      }
    };

    // Handle keydown on tabs
    const keydownEventListener = (event) => {
      const key = event.keyCode;

      switch (key) {
        case keys.end:
          event.preventDefault();
          // Activate last tab
          focusLastTab();
          break;
        case keys.home:
          event.preventDefault();
          // Activate first tab
          focusFirstTab();
          break;

        // Up and down are in keydown
        // because we need to prevent page scroll >:)
        case keys.up:
        case keys.down:
          determineOrientation(event);
          break;
        default:
          break;
      }
    };

    const addListeners = (index) => {
      tabs[index].addEventListener('click', clickEventListener);
      tabs[index].addEventListener('keydown', keydownEventListener);
      tabs[index].addEventListener('keyup', keyupEventListener);

      // Build an array with all tabs (<button>s) in it
      tabs[index].index = index;
    };

    generateArrays();

    // Bind listeners
    for (let i = 0; i < tabs.length; i += 1) {
      addListeners(i);
    }
  },
};
